import React from 'react';
import { Form, Input, Select } from '../../../../../components';
import { isValidIP } from '../../../../../lib/helpers';
import { IP_TYPE } from '../../../../../constants/network';

const IP_TYPE_OPTIONS = [
    { value: IP_TYPE.DHCP, label: 'DHCP' },
    { value: IP_TYPE.STATIC, label: 'Static' },
];

const requiredRule = (message) => ({ required: true, message });

const ipValidator = (message) => ({
    validator: async (_rule, value) => {
        if (value && !isValidIP(value)) {
            throw new Error(message);
        }
    },
});

export const SourceWorkerNetworkConfig = ({ name, disabled = false }) => {
    const form = Form.useFormInstance();
    const ipType = Form.useWatch([...name, 'ipType'], form) || IP_TYPE.DHCP;
    const isStatic = ipType === IP_TYPE.STATIC;
    const field = (key) => [...name, key];

    return (
        <>
            <Form.Item
                name={field('networkName')}
                label="Destination Network Name"
                rules={[requiredRule('Destination network name is required')]}
            >
                <Input placeholder="Enter destination network name" disabled={disabled} />
            </Form.Item>

            <Form.Item name={field('ipType')} label="IP Type" initialValue={IP_TYPE.DHCP}>
                <Select options={IP_TYPE_OPTIONS} disabled={disabled} />
            </Form.Item>

            {isStatic && (
                <>
                    <Form.Item
                        name={field('ipAddr')}
                        label="IP Address"
                        rules={[
                            requiredRule('IP Address is required'),
                            ipValidator('IP Address must be a valid IP address'),
                        ]}
                    >
                        <Input placeholder="Enter IP address" disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name={field('netmask')}
                        label="Netmask"
                        rules={[requiredRule('Netmask is required'), ipValidator('Netmask must be a valid IP address')]}
                    >
                        <Input placeholder="Enter netmask" disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name={field('gateway')}
                        label="Default Gateway"
                        rules={[
                            requiredRule('Default gateway is required'),
                            ipValidator('Default gateway must be a valid IP address'),
                        ]}
                    >
                        <Input placeholder="Enter default gateway" disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name={field('primaryDns')}
                        label="Primary DNS"
                        rules={[
                            requiredRule('Primary DNS is required'),
                            ipValidator('Primary DNS must be a valid IP address'),
                        ]}
                    >
                        <Input placeholder="Enter primary DNS" disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name={field('secondaryDns')}
                        label="Secondary DNS"
                        rules={[ipValidator('Secondary DNS must be a valid IP address')]}
                    >
                        <Input placeholder="Enter secondary DNS (optional)" disabled={disabled} />
                    </Form.Item>
                </>
            )}
        </>
    );
};

